module.exports = __webpack_public_path__ + "static/media/Sung-Icon-1.66b9cfb4.svg";